import { render, staticRenderFns } from "./AllTeachers.vue?vue&type=template&id=146dcece&scoped=true&"
import script from "./AllTeachers.vue?vue&type=script&lang=js&"
export * from "./AllTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146dcece",
  null
  
)

export default component.exports